// extracted by mini-css-extract-plugin
export default {"back":"recs_back__a-tAq","container":"recs_container__j7lTX","innerContainer":"recs_innerContainer__vcePX","spinner":"recs_spinner__AHfZL","dark":"recs_dark__XytVY"};